import React, { useState, useEffect } from "react";
import { Card, TextField, Select, MenuItem, Button, InputLabel, FormControl } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import axios from "axios";
import moment from "moment";

function Addassignment() {
  const [data, setdata] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [assignmenttitle, setassignmenttitle] = useState("");
  const [assignmentdate, setassignmentdate] = useState("");
  const [assignmentclassname, setassignmentclassname] = useState("");
  const [assignmentsubject, setassignmentsubject] = useState("");
  const [mark, setmark] = useState("");
  const [others, setothers] = useState("");
  const [type, settype] = useState("");
  const [standard, setstandard] = useState("");
  const [studentname, setstudentname] = useState("");

  useEffect(() => {
    getusers();
  }, []);

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files.length === 0) return; // Prevents adding empty selections
    setSelectedImages([...selectedImages, ...files]);
  };

  const getusers = async () => {
    try {
      const response = await axios.get("/api/user/getAllUser1");
      if (response.status === 200) {
        setdata(response.data.success);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  // const uploadFiles = async (id) => {
  //   try {
  //     const formData = new FormData();
  //     console.log("object", formData)
  //     for (let i = 0; i < selectedImages.length; i++) {
  //       formData.append("id", id);
  //       formData.append("assignmentfile", selectedImages[i]);
  //     }
  //    const res =  await fetch("/api/admin/addAssignmentFiles/", {
  //       method: "POST",
  //       body: formData,
  //     });
  //     console.log("res",res) 
  //   } catch (error) {
  //     console.error("Error uploading files:", error);
  //   }
  // };

  // const postimage = async (e) => {
  //   e.preventDefault();

  //   if (!assignmenttitle || !assignmentsubject || !others || !assignmentdate || !mark || !standard || !type || selectedImages.length === 0) {
  //     alert("Please fill all mandatory fields.");
  //     return;
  //   }

  //   try {
  //     const response = await axios.post("/api/admin/addassignment", {
  //       assignmenttitle,
  //       assignmentclassname,
  //       assignmentdate: moment(assignmentdate).format("DD/MM/YYYY"),
  //       assignmentsubject,
  //       others,
  //       mark,
  //       standard,
  //       studentid: studentname,
  //       assignmenttype: type,
  //     });

  //     console.log(" response............." , response)

  //     console.log("object",assignmenttitle,assignmentclassname,assignmentdate,assignmentsubject,others,mark,standard,studentname,type)

  //     if (response.status === 200) {
  //       await uploadFiles(response.data.success?._id);
  //       alert("Assignment added successfully!");
  //       window.location.assign("/admin/assignment");
  //     }
  //   } catch (error) {
  //     console.error("Error submitting assignment:", error);
  //   }
  // };



  const uploadFiles = async (id) => {
    if (selectedImages.length === 0) {
      console.error("No files selected for upload.");
      return;
    }
  
    try {
      const formData = new FormData();
      formData.append("id", id);
  
      selectedImages.forEach((file) => {
        formData.append("assignmentfile", file);
      });
  
      const res = await fetch("/api/admin/addAssignmentFiles/", {
        method: "POST",
        body: formData,
      });
  
      if (!res.ok) {
        const errorData = await res.json();
        console.error("File upload failed:", errorData);
      } else {
        console.log("Files uploaded successfully");
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };
  

  const postimage = async (e) => {
    e.preventDefault();
  
    if (!assignmenttitle || !assignmentsubject || !others || !assignmentdate || !mark || !standard || !type || selectedImages.length === 0) {
      alert("Please fill all mandatory fields.");
      return;
    }
  
    try {
      const formData = new FormData();
      formData.append("assignmenttitle", assignmenttitle);
      formData.append("assignmentclassname", assignmentclassname);
      formData.append("assignmentdate", moment(assignmentdate).format("DD/MM/YYYY"));
      formData.append("assignmentsubject", assignmentsubject);
      formData.append("others", others);
      formData.append("mark", mark);
      formData.append("standard", standard);
      formData.append("studentid", studentname);
      formData.append("assignmenttype", type);
  
      // Append files
      selectedImages.forEach((file) => {
        formData.append("assignmentfile", file);
      });
  
      const response = await axios.post("/api/admin/addassignment", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      console.log("Response:", response);
  
      if (response.status === 200) {
        alert("Assignment added successfully!");
        window.location.assign("/admin/assignment");
      }
    } catch (error) {
      console.error("Error submitting assignment:", error);
    }
  };
  



  return (
    <div className="container mt-5" style={{ maxWidth: "600px", margin: "auto" }}>
      <Card sx={{ p: 4, boxShadow: "0px 4px 12px rgba(0,0,0,0.1)", borderRadius: "10px", textAlign: "center" }}>
        <h4>Add Assignment</h4>
        <form onSubmit={postimage}>
          <TextField fullWidth label="Title" variant="outlined" margin="normal" onChange={(e) => setassignmenttitle(e.target.value)} />
          <TextField fullWidth label="Subject" variant="outlined" margin="normal" onChange={(e) => setassignmentsubject(e.target.value)} />

          <FormControl fullWidth margin="normal">
            <InputLabel>Assignment Type</InputLabel>
            <Select value={type} onChange={(e) => settype(e.target.value)}>
              <MenuItem value="standard">Whole class</MenuItem>
              <MenuItem value="student">Individual student</MenuItem>
            </Select>
          </FormControl>

          <TextField fullWidth label="Class Name" variant="outlined" margin="normal" onChange={(e) => setassignmentclassname(e.target.value)} />

          <FormControl fullWidth margin="normal">
            <InputLabel>Class Name List</InputLabel>
            <Select value={standard} onChange={(e) => setstandard(e.target.value)}>
              {[...Array(12)].map((_, i) => (
                <MenuItem key={i + 1} value={`Class ${i + 1}`}>{`Class ${i + 1}`}</MenuItem>
              ))}
            </Select>
          </FormControl>

          {type === "student" && (
            <FormControl fullWidth margin="normal">
              <InputLabel>Student Name</InputLabel>
              <Select value={studentname} onChange={(e) => setstudentname(e.target.value)}>
                <MenuItem value="">Select Student</MenuItem>
                {data.map((student) => (
                  <MenuItem key={student._id} value={student._id}>
                    {student.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <TextField fullWidth label="Others" variant="outlined" margin="normal" onChange={(e) => setothers(e.target.value)} />
          <TextField fullWidth label="Mark" type="number" variant="outlined" margin="normal" onChange={(e) => setmark(e.target.value)} />
          <TextField fullWidth label="Due Date" type="date" variant="outlined" margin="normal" InputLabelProps={{ shrink: true }} onChange={(e) => setassignmentdate(e.target.value)} />

          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <Button variant="contained" component="label" startIcon={<UploadFileIcon />}>
              Upload File
              <input type="file" hidden multiple onChange={handleFileChange} />
            </Button>
          </div>

          <Button fullWidth variant="contained" color="primary" sx={{ mt: 3 }} type="submit">
            Create Assignment
          </Button>
        </form>
      </Card>
    </div>
  );
}

export default Addassignment;
